import { useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faChartColumn,
  faChevronDown,
  faFileCirclePlus,
  faGaugeHigh,
  faGear,
  faMagnifyingGlass,
  faPlus,
} from "@fortawesome/free-solid-svg-icons";

import { useDropdown } from "./useDropdown";
import { useAccess } from "../../permissions/access";
import { actionsFor } from "../../navigation/actionRegistry";

const ICONS = {
  "new-construction": faFileCirclePlus, "new-maintenance": faFileCirclePlus, "new-emergency": faFileCirclePlus,
  "new-rehabilitation": faFileCirclePlus, "new-private": faFileCirclePlus, monitoring: faGaugeHigh, "pdc-indicators": faChartColumn,
  "daily-execution": faPlus, search: faMagnifyingGlass, "contract-settings": faGear,
};

/** الإجراءات السريعة — القائمة تُبنى حسب صلاحيات المستخدم (البند 16). */
export function QuickActions() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { open, toggle, close, containerRef } = useDropdown();

  // كل إجراء يظهر فقط إن كان مساره يُفتح للمستخدم (نفس شرط حماية المسار)
  const { permissions, isSuperAdmin: isAdmin } = useAccess();

  // تحديث 60: القائمة من سجل الإجراءات المركزي (موضع «topbar») — نفس الشكل والترتيب والسلوك السابق
  const actions = useMemo(
    () => actionsFor("topbar").map((a) => ({ key: a.id, icon: ICONS[a.id] || faPlus, label: a.i18n ? t(a.i18n) : a.title, path: a.route })),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [t, permissions, isAdmin]
  );

  if (actions.length === 0) return null;

  return (
    <div className="ah-quick" ref={containerRef}>
      <button
        type="button"
        className="ah-quick__trigger"
        onClick={toggle}
        aria-expanded={open}
        aria-haspopup="menu"
        aria-label={t("header.newAction")}
        data-testid="gh-new"
      >
        <FontAwesomeIcon icon={faPlus} />
        <span className="ah-quick__label">{t("header.newAction")}</span>
        <FontAwesomeIcon icon={faChevronDown} className={`ah-caret ${open ? "ah-caret--open" : ""}`} />
      </button>

      {open && (
        <div className="ah-menu ah-menu--quick" role="menu">
          <div className="ah-menu__head">
            <strong>{t("quickActions.title")}</strong>
          </div>
          {actions.map((action) => (
            <button
              key={action.key}
              type="button"
              className="ah-menu__item"
              role="menuitem"
              onClick={() => {
                close();
                navigate(action.path);
              }}
            >
              <FontAwesomeIcon icon={action.icon} />
              {action.label}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
